import { http } from "../../plugins/axios";

const state = () => ({});

const mutations = {};

const getters = {};

const cardService = import.meta.env.VITE_CARD_SERVICE_URL;

const actions = {
  // Mirrors the claims eligibility contract (see unemployment/checkEligibility):
  // GET .../eligibility -> { eligible: boolean, reasons: string[] }. The policy
  // toggle lives only in the cards API environment, so the frontend never holds a
  // build-time flag that could drift out of step with what the backend enforces.
  async checkCardRenewalEligibility(
    _ctx: any,
    payload?: { minor_nib_number?: number | string }
  ) {
    const endpoint = `${cardService}/application/card-renewal/eligibility`;

    const res = await http.get(endpoint, {
      params: payload?.minor_nib_number
        ? { minor_nib_number: payload.minor_nib_number }
        : undefined,
    });

    return res.data;
  },
  async getApplicant(
    _ctx: any,
    payload: { is_minor: boolean; minor_nib_number: number | string }
  ) {
    const endpoint = `${cardService}/application/applicant`;

    const res = await http.post(endpoint, payload);

    return res.data;
  },
  async saveApplication(_ctx: any, payload: any) {
    const endpoint = `${cardService}/pending/application`;

    const res = await http.post(endpoint, payload);

    return res.data;
  },
  async updatePendingApplication(_ctx: any, payload: any) {
    const endpoint = `${cardService}/pending/application/${payload.pending_data.pending_app_id}`;

    const res = await http.put(endpoint, payload);

    return res.data;
  },
  async submitApplication(_ctx: any, payload: any) {
    const endpoint = `${cardService}/application`;

    const res = await http.post(endpoint, payload);

    return res.data;
  },
  async getPendingApplications() {
    const endpoint = `${cardService}/pending/application`;

    const res = await http.get(endpoint);

    return res.data;
  },
  async getApplicationById(_ctx: any, applicationId: number | string) {
    const endpoint = `${cardService}/application/${applicationId}`;

    const res = await http.get(endpoint);

    return res.data;
  },
  async getSubmittedApplications(
    _ctx: any,
    filters: { page_size: number; page_number: number }
  ) {
    const endpoint = `${cardService}/application`;

    const res = await http.get(endpoint, {
      params: filters,
    });

    return res.data;
  },
  async getPendingApplicationById(_ctx: any, applicationId: number) {
    const endpoint = `${cardService}/pending/application/${applicationId}`;

    const res = await http.get(endpoint);

    return res.data;
  },
  async deletePendingApplication(_ctx: any, applicationId: number | string) {
    const endpoint = `${cardService}/pending/application/${applicationId}`;

    const res = await http.delete(endpoint);

    return res.data;
  },
  async deleteSubmittedApplication(_ctx: any, applicationId: number | string) {
    const endpoint = `${cardService}/application/${applicationId}`;

    const res = await http.delete(endpoint);

    return res.data;
  },
  async uploadPendingDocuments(_ctx: any, payload: any) {
    let endpoint = `${cardService}/pending/application/${payload.id}/files`;
    let res = await http.put(endpoint, payload.files, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res;
  },
  async uploadSubmittedDocuments(_ctx: any, payload: any) {
    let endpoint = `${cardService}/application/${payload.id}/files?reupload=${payload.reupload}`;
    let res = await http.put(endpoint, payload.files, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res;
  },
  async getDocumentTypes(_ctx: any, applicationType: string) {
    const endpoint = `${cardService}/documents`;
    const res = await http.get(endpoint, {
      params: {
        application_type: applicationType,
      },
    });

    return res.data;
  },
  async deletePendingAppDocument(
    _ctx: any,
    payload: { pendingAppId: number | string; path: string }
  ) {
    const endpoint = `${cardService}/pending/application/${payload.pendingAppId}/files`;
    const res = await http.post(endpoint, { file_path: payload.path });

    return res.data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
